import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PrimaryButton from '../StyledComponents/PrimaryButton';
import StandardDialog from '../StyledComponents/StandardDialog';
import {theme} from '../../Theme';

export default function RestrictedContentWarningDialog(props: $TSFixMe) {
  return (
    <StandardDialog open={props.open} hideCloseButton>
      <Grid container direction="column" alignItems="center">
        <Typography
          variant="subtitle1"
          fontSize={18}
          color={theme.palette.gray.dark}
          lineHeight={1.4}
          maxWidth={325}
          mt={1.5}
          mb={3}>
          Hey there! We noticed you're trying to share contact info. For
          everyone's safety and to ensure a successful project, we ask that all
          communication stays on the Bidmii platform. This way, we can keep a
          verifiable record of all agreements, messages, and shared documents.
          <br />
          <br />
          Thanks for understanding!
        </Typography>
        <PrimaryButton onClick={props.handleClose}>
          THANK YOU FOR PROTECTING ME
        </PrimaryButton>
      </Grid>
    </StandardDialog>
  );
}
